import { FooterConfig } from '@tenants/types/tenant';

export function createFooterConfig(): FooterConfig {
  return {
    footerColumns: {
      joinUsLink: '/search',
      footerImageData: {
        src: '/next/assets/images/zoocasa-footer-pic.png',
        alt: {
          key: '',
          defaultValue: 'A group of people at an event are laughing and cheering, with one man enthusiastically greeting a seated couple in the front row.',
        },
      },
    },
    showAccessibilityLink: true,
  };
}